// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"OPZBI4a22oeXrZvpI46o","tooltip":"_7U9t3gNtUjIckEtkp2X","fill_parent":"aGQcaG_cbK14vs5T0lwq","fillParent":"aGQcaG_cbK14vs5T0lwq","permanent":"rNkxTKkXQ9xyEt4F0Tpg"};